import IndustryExplorer from "../components/landing/IndustryExplorer";
import MotionEnhancer from "../components/landing/MotionEnhancer";
import "./Landing.css";

const stats = [
  { value: "2013", label: "Established" },
  { value: "02", label: "Offices" },
  { value: "03", label: "Plate exposing systems" },
  { value: "03", label: "Offset workshops" },
];

const capabilities = [
  {
    number: "01",
    title: "Prepress & plates",
    copy: "File preparation, colour correction, shade matching, thermal CTP and CTCP plate output.",
    accent: "cyan",
  },
  {
    number: "02",
    title: "Offset printing",
    copy: "Multiple sheet-fed formats for books, stationery, marketing collateral and cartons.",
    accent: "magenta",
  },
  {
    number: "03",
    title: "Packaging",
    copy: "Folding cartons, rigid-board formats, sleeves, labels and information inserts.",
    accent: "yellow",
  },
  {
    number: "04",
    title: "Finishing",
    copy: "Lamination, foil, embossing, spot UV, die-cutting, folding, pasting and binding.",
    accent: "red",
  },
];

const plateSystems = [
  {
    image: "/images/amsky-thermal-ctp.png",
    title: "AMSKY thermal CTP",
    detail: "High-speed thermal plate imaging",
    imageClass: "",
  },
  {
    image: "/images/kodak-thermal-ctp.jpg",
    title: "Kodak thermal CTP",
    detail: "Precise thermal plate output",
    imageClass: "",
  },
  {
    image: "/images/cron-ctcp-black.png",
    title: "CRON CTCP",
    detail: "High-speed CTCP plate output",
    imageClass: "",
  },
];

const presses = [
  {
    image: "/images/komori-lithrone-26.jpg",
    title: "Komori Lithrone 26",
    format: "19 × 26 in",
  },
  {
    image: "/images/shinohara-iv-52.jpg",
    title: "Shinohara IV-52",
    format: "12 × 18 in · 15 × 20 in",
  },
  {
    image: "/images/akiyama-hi-ace-28.jpg",
    title: "Akiyama Hi-Ace 28",
    format: "20 × 28 in",
  },
];

const industries = [
  {
    name: "Education",
    detail: "Books · magazines · registers",
    accent: "cyan",
    products: [
      { label: "Books and annual magazines", image: "/images/products/education-books.jpg" },
      { label: "Registers and exercise books", image: "/images/products/education-registers.jpg" },
      { label: "Question papers", image: "/images/products/education-question-paper.jpg" },
      { label: "Diaries and calendars", image: "/images/products/diaries-calendars.webp" },
      { label: "School and college stationery", image: "/images/products/education-stationery.jpg" },
    ],
  },
  {
    name: "Healthcare",
    detail: "Folders · forms · stationery",
    accent: "magenta",
    products: [
      { label: "Patient and report folders", image: "/images/products/healthcare-folders.jpg" },
      { label: "Forms and report formats", image: "/images/products/healthcare-forms.jpg" },
      { label: "Letterheads and envelopes", image: "/images/products/healthcare-letterheads.jpg" },
      { label: "Premium visiting cards", image: "/images/products/premium-visiting-cards.jpg" },
      { label: "Institutional stationery", image: "/images/products/healthcare-stationery.jpg" },
    ],
  },
  {
    name: "Corporate",
    detail: "Identity · diaries · annual reports",
    accent: "yellow",
    products: [
      { label: "Diaries and calendars", image: "/images/products/diaries-calendars.webp" },
      { label: "Letterheads and envelopes", image: "/images/products/corporate-letterheads.jpg" },
      { label: "Brochures and company profiles", image: "/images/products/corporate-brochures.jpg" },
      { label: "Folders and presentation kits", image: "/images/products/presentation-folders.jpg" },
      { label: "Annual reports", image: "/images/products/annual-reports.jpg" },
    ],
  },
  {
    name: "Retail & fashion",
    detail: "Tags · packaging · lookbooks",
    accent: "red",
    products: [
      { label: "Hang tags and product tags", image: "/images/products/retail-tags.jpg" },
      { label: "Packaging boxes", image: "/images/products/packaging-boxes.jpg" },
      { label: "Information inserts", image: "/images/products/product-inserts.webp" },
      { label: "Brochures and lookbooks", image: "/images/products/retail-lookbooks.jpg" },
      { label: "Samples and display collateral", image: "/images/products/retail-display.webp" },
      { label: "Wrapping and packaging paper", image: "/images/products/wrapping-paper.jpg" },
    ],
  },
  {
    name: "Hospitality",
    detail: "Menus · pads · guest collateral",
    accent: "navy",
    products: [
      { label: "Menus and table cards", image: "/images/products/hospitality-menus.png" },
      { label: "Guest stationery", image: "/images/products/hospitality-stationery.jpg" },
      { label: "Bill pads and forms", image: "/images/products/hospitality-bill-pads.jpg" },
      { label: "Folders and room collateral", image: "/images/products/hospitality-room-folders.jpg" },
      { label: "Event brochures", image: "/images/products/hospitality-event-brochures.png" },
    ],
  },
  {
    name: "FMCG & pharma",
    detail: "Packaging boxes · labels · leaflets",
    accent: "cyan",
    products: [
      { label: "Packaging boxes", image: "/images/products/packaging-boxes.jpg" },
      { label: "Labels and sleeves", image: "/images/products/packaging-labels.jpg" },
      { label: "Information leaflets", image: "/images/products/information-leaflets.webp" },
      { label: "Product inserts", image: "/images/products/printed-inserts.jpg" },
      { label: "Promotional print", image: "/images/products/promotional-print.jpg" },
    ],
  },
  {
    name: "Startups",
    detail: "Launch kits · packaging · collateral",
    accent: "magenta",
    products: [
      { label: "Launch and pitch kits", image: "/images/products/startup-launch-kit.jpg" },
      { label: "Starter packaging", image: "/images/products/packaging-boxes.jpg" },
      { label: "Brochures and catalogues", image: "/images/products/corporate-brochures.jpg" },
      { label: "Business stationery", image: "/images/products/corporate-letterheads.jpg" },
      { label: "Short-run brand collateral", image: "/images/products/product-inserts.webp" },
    ],
  },
  {
    name: "Offset printers",
    detail: "Exposed plates · dependable dispatch",
    accent: "yellow",
    products: [
      { label: "Thermal CTP plates", image: "/images/products/thermal-ctp-plates.png" },
      { label: "CTCP plates", image: "/images/products/ctcp-plates.jpeg" },
      { label: "File checking and preflight", image: "/images/products/prepress-file-check.jpg" },
      { label: "Multiple plate sizes", image: "/images/products/ctcp-plates.jpeg" },
      { label: "Timely plate dispatch", image: "/images/products/plate-dispatch.webp" },
    ],
  },
];

const workflow = [
  "Brief & specifications",
  "File setting & preflight",
  "Colour correction & proof",
  "Plate making & printing",
  "Finishing & quality check",
  "Packing & on-time dispatch",
];

export default function Landing() {
  return (
    <main className="landing-page">
      <MotionEnhancer />
      <a
        className="floating-whatsapp"
        href="https://wa.me/918585849393?text=Hello%20Jyoti%20Image%2C%20I%20would%20like%20to%20discuss%20a%20printing%20requirement."
        target="_blank"
        rel="noreferrer"
        aria-label="Chat with Jyoti Image on WhatsApp, available 24 hours"
      >
        <span className="whatsapp-icon" aria-hidden="true">
          <svg viewBox="0 0 32 32" role="presentation">
            <path d="M16.1 4.2a11.4 11.4 0 0 0-9.8 17.2L4.7 27.3l6-1.6a11.4 11.4 0 1 0 5.4-21.5Zm0 20.7c-1.8 0-3.6-.5-5.1-1.5l-.4-.2-3.5.9.9-3.4-.2-.4a9.2 9.2 0 1 1 8.3 4.6Zm5.1-6.9c-.3-.1-1.7-.8-1.9-.9-.3-.1-.5-.1-.7.2-.2.3-.7.9-.9 1.1-.2.2-.3.2-.6.1-1.8-.9-3-1.7-4.2-3.8-.3-.5.3-.5.9-1.7.1-.2 0-.4 0-.6l-.9-2.1c-.2-.5-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.3-1.2 1.2-1.2 2.9s1.3 3.4 1.4 3.6c.2.2 2.5 3.8 6 5.3 2.2 1 3.1 1 4.2.8.7-.1 1.7-.7 1.9-1.3.2-.6.2-1.2.2-1.3-.1-.1-.3-.2-.6-.3Z" />
          </svg>
        </span>
        <span className="whatsapp-label">
          <small>Available 24/7</small>
          <strong>WhatsApp us</strong>
        </span>
      </a>
      <div className="cmyk-strip" aria-hidden="true">
        <span />
        <span />
        <span />
        <span />
      </div>

      <header className="site-header">
        <a className="brand" href="#top" aria-label="Jyoti Image home">
          <img
            src="/images/jyoti-image-logo.png"
            alt="Jyoti Image"
            width="360"
            height="125"
          />
        </a>

        <nav className="main-nav" aria-label="Primary navigation">
          <a href="#about">About</a>
          <a href="#plate-services">Plate services</a>
          <a href="#direct-import">Imports</a>
          <a href="#offset-printing">Offset printing</a>
          <a href="#industries">Industries</a>
          <a href="#contact">Contact</a>
        </nav>

        <div className="portal-links" aria-label="Portal access">
          <a
            className="employee-link client-login-link"
            href="/client-login"
          >
            <span className="employee-dot client-dot" aria-hidden="true" />
            Client login
            <span className="portal-arrow" aria-hidden="true">↗</span>
          </a>
          <a
            className="employee-link"
            href="/login"
          >
            <span className="employee-dot" aria-hidden="true" />
            Employee login
            <span className="portal-arrow" aria-hidden="true">↗</span>
          </a>
        </div>
      </header>

      <section className="hero" id="top">
        <div className="hero-copy">
          <div className="eyebrow">
            <span className="eyebrow-line" />
            Kolkata · Since 2013
          </div>

          <h1>
            <span className="hero-title-line">From Plate</span>
            <span className="hero-title-line hero-title-accent">to Print.</span>
          </h1>

          <p className="hero-lede">
            Prepress, offset printing and packaging for institutions,
            businesses and brands—coordinated with care from the first file
            check through final delivery.
          </p>

          <div className="hero-route" aria-label="Perfection at every production stage">
            <div className="hero-route-heading">
              <span>Perfection at every stage</span>
            </div>
            <ol>
              <li>
                <span className="route-index route-cyan">01</span>
                <strong>File</strong>
              </li>
              <li>
                <span className="route-index route-magenta">02</span>
                <strong>Plate</strong>
              </li>
              <li>
                <span className="route-index route-yellow">03</span>
                <strong>Print</strong>
              </li>
              <li>
                <span className="route-index route-black">04</span>
                <strong>Fabrication</strong>
              </li>
            </ol>
          </div>

          <div className="hero-actions">
            <a
              className="button button-primary"
              href="https://wa.me/918585849393"
              target="_blank"
              rel="noreferrer"
            >
              Start a print enquiry <span aria-hidden="true">↗</span>
            </a>
            <a className="button button-secondary" href="#plate-services">
              Explore capabilities <span aria-hidden="true">↓</span>
            </a>
          </div>

          <p className="micro-proof">Precision. Reliability. Commitment.</p>
        </div>

        <div className="hero-visual" aria-label="Premium finished print products">
          <img
            src="/images/jyoti-hero-premium.png"
            alt="Premium books, packaging, brochures and print samples arranged in a studio composition"
            width="1024"
            height="1536"
          />
          <div className="hero-badge">
            <span>Prepress</span>
            <span>Offset</span>
            <span>Packaging</span>
          </div>
          <div className="registration-mark registration-mark-one" aria-hidden="true" />
          <div className="registration-mark registration-mark-two" aria-hidden="true" />
        </div>
      </section>

      <section className="stat-band" aria-label="Company at a glance">
        <p>Built to coordinate complex print requirements.</p>
        <div className="stats-grid">
          {stats.map((stat) => (
            <article key={stat.label}>
              <strong>{stat.value}</strong>
              <span>{stat.label}</span>
            </article>
          ))}
        </div>
      </section>

      <section className="opening-statement" id="about">
        <p className="section-kicker">Hands-on management</p>
        <div className="opening-headline">
          <h2>Every job is treated like a promise made personally.</h2>
          <div className="management-pillars" aria-label="Our priorities">
            <span>Customer satisfaction</span>
            <span>Consistent quality</span>
            <span>Timely service</span>
          </div>
        </div>
        <div className="opening-copy">
          <p>
            Founded by Ananta Jyoti Roy and Dibya Jyoti Roy, Jyoti Image is led
            with close, day-to-day involvement—from understanding the job and
            approving colour to monitoring production and delivery.
          </p>
          <p>
            Multiple offset press formats, in-house plate making and
            coordinated finishing are supported by skilled operators and a
            dependable delivery team to complete on-time assignments with
            precision and a constant eye on perfection.
          </p>
        </div>
        <div className="partner-roster" aria-label="Messages from Jyoti Image leadership">
          <article className="partner-card partner-card-founder">
            <figure className="partner-portrait">
              <img
                src="/images/ananta-jyoti-roy.webp"
                alt="Ananta Jyoti Roy, Founder of Jyoti Image"
                loading="lazy"
              />
            </figure>
            <div className="partner-message">
              <p className="partner-role">Founder</p>
              <h3>Ananta Jyoti Roy</h3>
              <blockquote>
                “Technology may produce the plate, but service builds the relationship.
                My goal is to ensure that every customer who comes to Jyoti Image
                receives prompt attention, dependable quality and support when it
                matters most. We want to be known not only for the plates we expose,
                but for the standard of service that accompanies every one of them.”
              </blockquote>
            </div>
          </article>
          <article className="partner-card partner-card-cofounder">
            <figure className="partner-portrait partner-portrait-dibya">
              <img
                src="/images/dibya-jyoti-roy.webp"
                alt="Dibya Jyoti Roy, Co-founder of Jyoti Image"
                loading="lazy"
              />
            </figure>
            <div className="partner-message">
              <p className="partner-role">Co-founder</p>
              <h3>Dibya Jyoti Roy</h3>
              <blockquote>
                “Every customer who chooses Jyoti Image becomes part of our journey.
                We will continue to grow, improve and adopt the finest technology,
                but our promise will remain unchanged: to value every assignment,
                honour every commitment and deliver quality with care.”
              </blockquote>
            </div>
          </article>
        </div>
      </section>

      <section className="capabilities-section" id="capabilities">
        <div className="section-heading">
          <div>
            <p className="section-kicker">Capabilities</p>
            <h2>One coordinated route from file to finished piece.</h2>
          </div>
          <p>
            From a raw file or PDF, our team prepares the artwork for
            production, checks fonts and bleed, corrects colour, matches shades
            against approved printed references, selects the right press and
            finish, and stays with the job until it is delivered.
          </p>
        </div>

        <div className="capability-grid">
          {capabilities.map((capability) => (
            <article
              className={`capability-card accent-${capability.accent}`}
              key={capability.number}
            >
              <span className="capability-number">{capability.number}</span>
              <h3>{capability.title}</h3>
              <p>{capability.copy}</p>
              <span className="card-arrow" aria-hidden="true">↗</span>
            </article>
          ))}
        </div>
      </section>

      <section className="plate-service-section" id="plate-services">
        <div className="plate-service-intro">
          <div>
            <p className="section-kicker light-kicker">Prepress & exposed plates</p>
            <h2>Plate service built for printers who cannot afford to wait.</h2>
          </div>
          <div className="plate-service-copy">
            <p>
              We serve offset printers with dependable thermal CTP and CTCP
              output, careful file handling and timely dispatch. Every file is
              checked by our prepress team before the plate is exposed and sent
              out within the committed service window.
            </p>
            <a
              className="plate-brief-button"
              href="https://wa.me/918585849393"
              target="_blank"
              rel="noreferrer"
            >
              Send a plate brief <span aria-hidden="true">↗</span>
            </a>
          </div>
        </div>

        <div className="plate-metrics" aria-label="Plate service capacity">
          <article>
            <strong>2,000+</strong>
            <span>Plates per day capacity</span>
          </article>
          <article>
            <strong>03</strong>
            <span>High-speed plate exposing systems</span>
          </article>
          <article>
            <strong>8–9</strong>
            <span>8 AM–9 PM customer service window</span>
          </article>
        </div>

        <div className="plate-grid">
          {plateSystems.map((system, index) => (
            <article className="plate-card" key={system.title}>
              <div className="plate-image">
                <img
                  src={system.image}
                  alt={system.title}
                  className={system.imageClass}
                  width="960"
                  height="720"
                  loading="lazy"
                />
                <span>0{index + 1}</span>
              </div>
              <div className="plate-card-copy">
                <h3>{system.title}</h3>
                <p>{system.detail}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="plate-import-section" id="direct-import">
        <div className="import-art">
          <span className="import-mark" aria-hidden="true">CMYK</span>
          <img
            src="/images/import-container-outline.svg"
            alt="Outline of a container ship representing direct plate imports"
            width="720"
            height="520"
          />
          <div className="import-route">
            <span>Manufacturer</span>
            <i aria-hidden="true">→</i>
            <span>Jyoti Image</span>
          </div>
        </div>
        <div className="import-heading">
          <p className="section-kicker">Direct plate sourcing</p>
          <h2>Double-layer coated plates, imported directly.</h2>
        </div>
        <div className="import-copy">
          <p>
            We source plates directly from manufacturers in China, giving us
            closer control over supply, material consistency and size
            availability for our own production and the printers we serve.
          </p>
          <p>
            Direct importing supports dependable stock, competitive service
            and timely exposure—even when plate demand is high.
          </p>
          <div className="import-tags">
            <span>Double-layer coated</span>
            <span>Direct from manufacturer</span>
            <span>Wide size coverage</span>
            <span>Supply continuity</span>
          </div>
        </div>
      </section>

      <section className="press-section" id="offset-printing">
        <div className="press-intro">
          <div>
            <p className="section-kicker light-kicker">Offset press room</p>
            <h2>Multiple formats, selected around the job.</h2>
          </div>
          <p>
            Top-of-the-line technology, experienced operators and close
            management oversight help us plan every job for the right format,
            quality and delivery commitment.
          </p>
        </div>

        <div className="press-grid">
          {presses.map((press, index) => (
            <article className="press-card" key={press.title}>
              <div className="press-image">
                <img
                  src={press.image}
                  alt={press.title}
                  width="900"
                  height="660"
                  loading="lazy"
                />
                <span>0{index + 1}</span>
              </div>
              <div className="press-card-copy">
                <h3>{press.title}</h3>
                <p>{press.format}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="industries-section" id="industries">
        <div className="section-heading industries-heading">
          <div>
            <p className="section-kicker">Industries</p>
            <h2>Print built around the way your organisation works.</h2>
          </div>
          <p>
            From repeat stationery programmes and exposed plates to product
            launches and specialised packaging, every job follows an approved
            specification and delivery commitment.
          </p>
        </div>

        <div className="industry-grid expanded-industry-grid">
          {industries.map((industry, index) => (
            <IndustryExplorer
              industry={industry}
              index={index}
              key={industry.name}
            />
          ))}
        </div>
      </section>

      <section className="printer-callout">
        <div className="printer-callout-copy">
          <p className="section-kicker light-kicker">For offset printers</p>
          <h2>Your plate desk, backed by three high-speed systems.</h2>
          <p>
            Send production-ready files or ask us to help prepare them. Our
            prepress team checks the file, exposes the right plate and
            coordinates dispatch within the committed service window.
          </p>
        </div>
        <div className="printer-callout-points">
          <span>Thermal CTP + CTCP</span>
          <span>Double-layer coated plates</span>
          <span>8 AM–9 PM customer service window</span>
          <span>2,000+ plates per day capacity</span>
        </div>
      </section>

      <section className="delivery-section">
        <div>
          <p className="section-kicker">Distribution</p>
          <h2>Strong across Eastern India. Ready for pan-India delivery.</h2>
        </div>
        <div className="delivery-regions">
          <span>West Bengal</span>
          <span>Northeast India</span>
          <span>Odisha</span>
          <span>Jharkhand & Ranchi</span>
          <span className="region-wide">Pan-India dispatch</span>
        </div>
      </section>

      <section className="workflow-section">
        <div className="workflow-copy">
          <p className="section-kicker">Production workflow</p>
          <h2>A clear process protects quality and timelines.</h2>
          <p>
            The file, colour, plate, print and finish are checked at the right
            stages so the delivered job matches what was approved and promised.
          </p>
        </div>

        <ol className="workflow-list">
          {workflow.map((step, index) => (
            <li key={step}>
              <span>{String(index + 1).padStart(2, "0")}</span>
              <strong>{step}</strong>
            </li>
          ))}
        </ol>
      </section>

      <section className="employee-gateway" id="employee-access">
        <div>
          <p className="section-kicker light-kicker">For the Jyoti Image team</p>
          <h2>Operations, job data and challans stay one click away.</h2>
        </div>
        <a className="button employee-gateway-button" href="/login">
          Continue to employee login <span aria-hidden="true">↗</span>
        </a>
      </section>

      <section className="contact-section" id="contact">
        <div className="contact-lead">
          <p className="section-kicker">Start a conversation</p>
          <h2>Tell us what you need to print.</h2>
          <p>
            Share the file, size, quantity, material, colour, finishing and
            delivery date. Our team will help shape a clear, production-ready
            requirement.
          </p>
          <a
            className="button button-primary contact-button"
            href="https://wa.me/918585849393"
            target="_blank"
            rel="noreferrer"
          >
            WhatsApp +91 85858 49393 <span aria-hidden="true">↗</span>
          </a>
        </div>

        <div className="contact-details">
          <article>
            <span>Call</span>
            <a href="tel:+917980883146">+91 79808 83146</a>
            <a href="tel:+918240628486">+91 82406 28486</a>
          </article>
          <article>
            <span>Email</span>
            <a href="mailto:info@jyotiimage.com">info@jyotiimage.com</a>
            <a href="mailto:jyotiimage@yahoo.in">jyotiimage@yahoo.in</a>
          </article>
          <article>
            <span>Registered office</span>
            <p>67/B, Surya Sen Street<br />Kolkata – 700009</p>
          </article>
        </div>
      </section>

      <footer className="site-footer">
        <img
          src="/images/jyoti-image-logo.png"
          alt="Jyoti Image"
          width="360"
          height="125"
        />
        <p>From Plate to Print.</p>
        <div className="footer-links">
          <a href="#top">Back to top ↑</a>
          <a
            href="/login"
          >
            Employee login ↗
          </a>
        </div>
      </footer>
    </main>
  );
}

